/**
* Scrolling CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
    },
    finalize: function() {
      // Loop through each instance of `.scrolling-cta`
      $( this.selector() ).each( function() {
        const $container = $( this );
        const $images = $container.find( '.fade-img' );
        const $section = $container.find( '.scroll-images' );
        const $inner = $container.find( '.scroll-images-inner' );
        const $offset = 'top ' + ( $( '.navbar' ).outerHeight() + $( '#wpadminbar' ).outerHeight() + $( '#subnav' ).outerHeight() ) + 'px';

        // Animate images on scroll
        $images.each( function() {
          ScrollTrigger.create( {
            trigger: this,
            start: 'top 95%',
            toggleClass: {targets: this, className: 'in-view'},
          } );
        } );

        // Apply only on desktops (above 992px)
      } );
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-cta', COMPONENT );
} )( app );
